"use client"

import { useEffect, useState } from "react"

export function useSheetLayoutHeight(open: boolean): number {
  const [layoutViewportHeight, setLayoutViewportHeight] = useState(() =>
    typeof window !== "undefined" ? window.innerHeight : 0,
  )

  useEffect(() => {
    if (!open || typeof window === "undefined") return

    const update = () => {
      setLayoutViewportHeight(window.innerHeight || 0)
    }

    update()
    window.addEventListener("resize", update)
    window.addEventListener("orientationchange", update)

    return () => {
      window.removeEventListener("resize", update)
      window.removeEventListener("orientationchange", update)
    }
  }, [open])

  return layoutViewportHeight
}

export function resolveLayoutDvh(value: string, layoutViewportHeight: number): string {
  if (!value.includes("dvh") || !layoutViewportHeight) return value
  return value.replace(/(\d+(?:\.\d+)?)dvh/gi, (_, num) => {
    const ratio = parseFloat(num) / 100
    return `${layoutViewportHeight * ratio}px`
  })
}
